export default __webpack_public_path__ + "static/media/wwm.578fe34f.mp4";